// extracted by mini-css-extract-plugin
export default {"wrapper":"FormWrapper_wrapper__y4s2o"};